/**
 * @flow
 * */
import React from 'react';
import settings from 'config/constants';

// eslint-disable-next-line import/extensions
const GrmtPlayersGroupsLists = React.lazy(() => import('./views/pages/GrmtPlayersGroupsLists'));
// eslint-disable-next-line import/extensions
const GrmtPlayersGroup = React.lazy(() => import('./views/pages/GrmtPlayersGroup'));

const modulePath = `/${settings.PRODUCTS.GRMT.path}/player-groups`;

type Route = {
  path: string,
  name: string,
  exact: boolean,
  page: Function,
  subRoutes?: Array<Route>,
}

const ROUTES: Array<Route> = [
  { path: `${modulePath}`, name: 'PlayerGroup', exact: true, page: GrmtPlayersGroupsLists },
  { path: `${modulePath}/:id`, name: 'PlayerGroupList', exact: true, page: GrmtPlayersGroup }
];

export default ROUTES;
